import React from 'react';
import { IntlProvider } from '../../util/reactIntl';
import { useLanguage } from '../../context/languageContext';

const DynamicIntlProvider = ({ children, fallbackMessages = {} }) => {
  const { currentLocale, messages, isLoading } = useLanguage();

  // Show loading state or fallback while messages are loading
  if (isLoading && Object.keys(messages).length === 0) {
    return (
      <IntlProvider
        locale={currentLocale}
        messages={fallbackMessages}
        textComponent="span"
      >
        {children}
      </IntlProvider>
    );
  }

  return (
    <IntlProvider
      locale={currentLocale}
      messages={{ ...fallbackMessages, ...messages }}
      textComponent="span"
    >
      {children}
    </IntlProvider>
  );
};

export default DynamicIntlProvider; 